import { Tag } from 'antd';
import { ListResponseRetargetingListBean, RetargetingListBean } from 'common/api/api';
import { retargetingListApi } from 'common/api/entitiesApi';
import { ListCard } from 'common/components/ListCard';
import { AdvertiserSelector } from 'common/components/reloadable/AdvertiserSelector';
import { SearchInput } from 'common/components/SearchInput';
import { useAppContext } from 'common/context/AppContext';
import { CommonRoutes } from 'common/context/commonRoutes';
import { COLUMN_ID_WIDTH, COLUMN_NAME_WIDTH } from 'common/util/constants';
import { initListFilters, useListFilters } from 'common/util/useListFilters';
import { apiCall } from 'common/util/Util';
import dayjs from 'dayjs';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import StatusEnum = RetargetingListBean.StatusEnum

export const retargetingListStatusColors: Record<StatusEnum, string> = {
  [StatusEnum.NEW]: '#CAEBD2E5',
  [StatusEnum.PENDING]: '#CAEBD2E5',
  [StatusEnum.READY]: '#CAEBD2E5',
  [StatusEnum.FAILED]: '#FFE6DE',
}

const RetargetingListList = ({ agency }: { agency?: boolean }) => {
  const appContext = useAppContext()
  const [loading, setLoading] = useState(false)
  const [filters, setFilters] = useState(initListFilters())
  const { setFilter } = useListFilters(setFilters)
  const [listData, setListData] = useState<ListResponseRetargetingListBean>()

  const loadData = () => {
    apiCall(
      setLoading,
      appContext,
      () =>
        retargetingListApi.list(
          filters.sort?.name,
          filters.sort?.direction,
          filters.name,
          filters.advertiserId,
          false,
          {
            query: { page: filters.page, size: filters.pageSize },
          },
        ),
      (response) => setListData(response),
    )
  }

  return (
    <ListCard
      loading={loading}
      title="Retargeting Lists"
      filters={filters}
      setFilters={setFilters}
      listData={listData}
      loadData={loadData}
      columns={[
        {
          title: 'ID',
          dataIndex: 'id',
          width: COLUMN_ID_WIDTH,
          fixed: 'left',
        },
        {
          title: 'Name',
          dataIndex: 'name',
          className: 'list-table-name',
          sorter: true,
          ellipsis: true,
          render: (text, record: RetargetingListBean) => (
            <Link style={{ color: '#5888CF', minWidth: 100 }} to={`${CommonRoutes.RETARGETING_LIST}/${record.id}`}>
              {text}
            </Link>
          ),
          width: COLUMN_NAME_WIDTH,
          fixed: 'left',
        },
        {
          title: 'Status',
          dataIndex: 'status',
          width: 150,
          render: (_, record: RetargetingListBean) => (
            <Tag color={retargetingListStatusColors[record.status as StatusEnum]} style={{ color: '#0D1A43', width: 80, textAlign: 'center' }}>
              {record.status}
            </Tag>
          ),
        },
        {
          title: 'Ad Groups',
          dataIndex: 'adGroupIds',
          width: 120,
          render: (value: number[] | undefined, record: RetargetingListBean) => (
            <Link style={{ color: '#5888CF' }} to={`${CommonRoutes.AD_GROUP}?retargetingListId=${record.id}`}>
              {value?.length ?? 0}
            </Link>
          ),
        },
        {
          title: 'Collected ID Count',
          key: 'collectedIdCount',
          width: 150,
          render: (_, record: RetargetingListBean) =>
            (record.collectedIpUaCount || 0) + (record.collectedIfaCount || 0),
        },
        {
          title: 'Auto Update',
          dataIndex: 'autoUpdate',
          width: 150,
          render: (value: boolean | undefined) => (value ? 'Enabled' : 'Disabled'),
        },
        {
          title: 'Creation Date',
          dataIndex: 'created',
          sorter: true,
          width: 150,
          render: (date: Date | string | undefined) => (date ? dayjs(date).format('DD MMM YYYY') : '-'),
        },
      ]}
    >
      <SearchInput value={filters.name} onChange={(value) => setFilter('name', value)} />
      {agency && (
        <AdvertiserSelector
          placeholder="Filter by Advertiser"
          style={{ minWidth: '220px' }}
          value={filters.advertiserId}
          onChange={(value: number) => setFilter('advertiserId', value)}
        />
      )}
    </ListCard>
  )
}

export default RetargetingListList
